module.exports = __webpack_public_path__ + "static/media/face1b.a7b536af.jpg";